// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

const AssetsSearchBar = props => {
  const {
    searchTerm,
    clearSearch,
    setSearchTerm,
    clearAccountSelection,
  } = props;

  return (
    <div className="assetssearchbar-wrapper">
      <span className="assetssearchbar-search-icon">
        <FontAwesomeIcon icon={["far", "search"]} />
      </span>
      <input
        className="formcontrol assetssearchbar-search"
        type="text"
        placeholder="Search Accounts.."
        value={searchTerm}
        onChange={setSearchTerm}
        onClick={clearAccountSelection}
        data-test="assetssearchbar-input"
      />
      <Tooltip placement="right" overlay="Clear search">
        <span
          className={`assetssearchbar-clear-searchbtn ${
            searchTerm.length === 0 ? "hide-item" : ""
          }`}
          onClick={clearSearch}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <FontAwesomeIcon icon={["far", "times-circle"]} />
        </span>
      </Tooltip>
    </div>
  );
};

export default AssetsSearchBar;



// WEBPACK FOOTER //
// ./src/components/AssetsWrapper/AssetsSearchBar/index.js